export const downloadObjectAsFile = (object: Object, filename: string) => {
    const anchor = document.createElement('a')
    anchor.setAttribute('href', `data:text/jsoncharset=utf-8,${encodeURIComponent(JSON.stringify(object, null, 2))}`)
    anchor.setAttribute('download', `${filename}.json`)
    document.body.appendChild(anchor)
    anchor.click()
    anchor.remove()
}
